module.exports = __webpack_public_path__ + "img/right-arrow-blue.c0a5c1f1.svg";